import { render, staticRenderFns } from "./g-uploadfile.vue?vue&type=template&id=e96cbac8&scoped=true"
import script from "./g-uploadfile.vue?vue&type=script&lang=js"
export * from "./g-uploadfile.vue?vue&type=script&lang=js"
import style0 from "./g-uploadfile.vue?vue&type=style&index=0&id=e96cbac8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e96cbac8",
  null
  
)

export default component.exports